import axios from "axios";

export interface IGetBookingsDisambiguationJimpiCountParams {
    tenants?: string[],
    dealers?: string[],
}

export const getCountDisuabiguationJimpi = async (): Promise<number> => {
    const response = await axios.get(`booking/import/countDisambiguation`);
    return response.data;
};

export const getCountDisuabiguationJimpiWithFilters = async (params: IGetBookingsDisambiguationJimpiCountParams): Promise<number> => {
    
    const baseUrl = `booking/import/countDisambiguation`;
    let url = baseUrl;

    let response = null;

    if(params.tenants !== undefined && params.tenants != null && params.tenants.length !== 0){
        url = url + `?tenants=${params.tenants.join(',')}`;
    }

    if(params.dealers !== undefined && params.dealers != null && params.dealers.length !== 0){
        if(url === baseUrl){
            url = url + `?`;
        }else{
            url = url + `&`;
        }
        
        url = url + `dealers=${params.dealers.join(',')}`;
    }

    response = await axios.get(url);
    return response.data;
};
